export interface SmallBusinessContribution {
  employee_amount: number;
  dependent_amount: number;
  type: ContributionType;
}

export enum ContributionType {
  Percentage = 'percentage',
  Flat = 'flat',
}
